import type { NavigableItem } from './types';

let nextId = 0;
export const generateId = () => `kb-nav-${++nextId}`;

export function sortByDomPosition(entries: [string, NavigableItem][]): [string, NavigableItem][] {
	return entries
		.filter(([, navigableItem]) => navigableItem.ref.current !== null)
		.sort(([, itemA], [, itemB]) => {
			const nodeA = itemA.ref.current;
			const nodeB = itemB.ref.current;

			if (!nodeA || !nodeB) {
				return 0;
			}

			// eslint-disable-next-line no-bitwise
			if (nodeA.compareDocumentPosition(nodeB) & Node.DOCUMENT_POSITION_FOLLOWING) {
				return -1;
			}

			// eslint-disable-next-line no-bitwise
			if (nodeA.compareDocumentPosition(nodeB) & Node.DOCUMENT_POSITION_PRECEDING) {
				return 1;
			}

			return 0;
		});
}
